import React, { useContext } from 'react';
import ContextApp from "../../../core/contexts/context.app";
import ServiceStorage from '../../../core/services/service.storage';
import ServiceApi from '../../../core/services/service.api';
import { Card } from 'react-bootstrap';
import ApiAuth from '../../../core/api/api.auth';

const Logout = () => {
  const ctx = useContext(ContextApp);

  if (ServiceStorage.getRefreshToken()) {
    const result = ApiAuth.logout({ refreshToken: ServiceStorage.getRefreshToken() });
  }

  ctx.setIsAuth(false);
  //ServiceApi.logout();

  return (
    <div className={`card card-custom`}>
      {/* Start Box Header */}
      <div className="card-header border-0 pt-5 mx-auto mb-5" >
        <Card style={{ width: '25rem' }} className="mx-auto text-center">
          <Card.Body>
            <Card.Title>با تشکر</Card.Title>
            <Card.Text>
              به امید دیدار مجدد شما
            </Card.Text>
            <Card.Link href='/#/login'>
              جهت ورود به سامانه کلیک نمایید
            </Card.Link>
          </Card.Body>
        </Card>
      </div>
    </div >
  );
}

export default Logout;